import { prefix } from '../../utils/prefix';

const Url = {
  upload: `${prefix}/attachment/upload`,
  done: `${prefix}/sign/completeSign`,
  delete: `${prefix}/attachment/delete`,
  download: `${prefix}/download`,
  getFileList: `${prefix}/attachment/getFileList`,
};

export default Url;
